import React, { createContext, useContext, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import ForecastingFilters from './forecasting-filters/ForecastingFilters';
import ForecastingVisualisationSettings from './ForecastingVisualisationSettings';
import ForecastingRunner from './ForecastingRunner';
import CSS from 'csstype';
import ForecastingCard from '../ForecastingCard';

export enum DateRangeStatus {
    Valid,
    Malformed,
    PastDate
}

/**********************************************************************************************************************/
/*************** Primary Forecasting State: tracks GraphQL (mutation) forecast request  *******************************/
/**********************************************************************************************************************/
const PrimaryForecastingContext = createContext({
    isPrimaryForecastingLoading: false,
    setPrimaryForecastingLoading: (isLoading: boolean) => {},
    inputDateRangeStatus: DateRangeStatus.Valid,
    setInputDateRangeStatus: (inputDateRangeStatus: DateRangeStatus) => {}
});
export const usePrimaryForecastingState = () => useContext(PrimaryForecastingContext);
/**********************************************************************************************************************/
export default function ForecastingPanel() {
    const [isPrimaryForecastingLoading, setPrimaryForecastingLoading] = useState(false);
    const [inputDateRangeStatus, setInputDateRangeStatus] = useState(DateRangeStatus.Valid);

    return (
        <div style={{margin: '16px'}}>
            <PrimaryForecastingContext.Provider value={{
                isPrimaryForecastingLoading: isPrimaryForecastingLoading,
                setPrimaryForecastingLoading: setPrimaryForecastingLoading,
                inputDateRangeStatus: inputDateRangeStatus,
                setInputDateRangeStatus: setInputDateRangeStatus
            }}>
                <ForecastingCard footer={(<>  <ForecastingRunner /> <ForecastingVisualisationSettings /> </>)}>
                    <div className='w-fit'>
                        <span style={forecastingSettingsTitle}>
                            Forecasting settings
                        </span>
                    </div>
                        <ForecastingFilters />
                </ForecastingCard>
            </PrimaryForecastingContext.Provider>
        </div>
    );
}

const forecastingSettingsTitle: CSS.Properties = {
    display: 'block',
    fontWeight: '600',
    fontSize: '16px',
    color: 'text-gray-600',
}
